export const GET_REPORTS_CURRENT_ORDERS: string =
  'src/pages/reports/GET_REPORTS_CURRENT_ORDERS';
export const GET_REPORTS_CURRENT_ORDERS_SUCCESS: string =
  'src/pages/reports/GET_REPORTS_CURRENT_ORDERS_SUCCESS';
export const GET_REPORTS_CURRENT_ORDERS_FAILED: string =
  'src/pages/reports/GET_REPORTS_CURRENT_ORDERS_FAILED';

export const GET_REPORTS_CENTER_ORDERS: string =
  'src/pages/reports/GET_REPORTS_CENTER_ORDERS';
export const GET_REPORTS_CENTER_ORDERS_SUCCESS: string =
  'src/pages/reports/GET_REPORTS_CENTER_ORDERS__SUCCESS';
export const GET_REPORTS_CENTER_ORDERS_FAILED: string =
  'src/pages/reports/GET_REPORTS_CENTER_ORDERS_FAILED';
